import React from 'react';

import { Card, Icon } from '../../../components/common';

interface DashboardWidgetCardProps {
    title: string;
    icon: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    testId?: string;
}

export const DashboardWidgetCard: React.FC<DashboardWidgetCardProps> = ({
    title,
    icon,
    children,
    footer,
    testId,
}) => (
    <Card variant="outlined" className="p-6 h-full" data-testid={testId}>
        <div className="flex items-start justify-between gap-3 mb-4">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2">
                <Icon name={icon} className="text-primary" />
                {title}
            </h3>
            {footer}
        </div>
        {children}
    </Card>
);
